export default {
  root: ({ props }) => ({
    class: [
      'inline-flex select-none align-bottom outline-transparent bg-surface-200',
      'border rounded-lg [&>button]:rounded-none [&>button]:border-none',
      '[&>button:first-child]:border-r-none [&>button:first-child]:rounded-r-none [&>button:first-child]:rounded-tl-lg [&>button:first-child]:rounded-bl-lg',
      '[&>button:last-child]:border-l-none [&>button:first-child]:rounded-l-none [&>button:last-child]:rounded-tr-lg [&>button:last-child]:rounded-br-lg',
      '[&>button]:flex-1',

      {
        '[&>button]:bg-zinc-200': props.ptOptions?.variant === 'custom',
        '[&>button]:before:w-[calc(100%-16px)] [&>button]:before:h-[calc(100%-16px)] [&>button]:before:top-[8px] [&>button]:before:left-[8px]': props.ptOptions?.variant === 'custom',
        '[&>button[data-p="checked"]]:before:shadow-md [&>button[data-p="checked"]]:before:border-surface-400 [&>button[data-p="checked"]]:before:border-[1px] [&>button:hover]:before:border-[1px] [&>button:hover]:before:border-surface-400': props.ptOptions?.variant === 'custom'
      },
      // 'before:border before:bg-white before:h-[cacl(100%-8px)]',

      // Invalid State
      {
        'border-red-500 dark:border-red-400': props.invalid,
        'border-transparent': !props.invalid
      }
    ]
  })
}
